/* Publish by EComposer at 2026-10-13 12:55:00*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1ptxmuy2uwn"]=  window.__ectimmers["ecom-1ptxmuy2uwn"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1ptxmuy2uwn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ptxmuy2uwn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nr7vxls76xl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nr7vxls76xl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwn0k00h7w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwn0k00h7w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh3ofv9y6lh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh3ofv9y6lh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khm7ypcsf1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khm7ypcsf1s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34va3iu904v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34va3iu904v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qorglxaid9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qorglxaid9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i2sjcgla5kg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i2sjcgla5kg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pggm1twnetd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pggm1twnetd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3h8cbtv2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3h8cbtv2i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-miaiwgcc31f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-miaiwgcc31f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-262gpo1gdrbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-262gpo1gdrbh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4551smdraz1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4551smdraz1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8fetvhycel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8fetvhycel', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yyrmidnhte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yyrmidnhte', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04gvok85lru').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04gvok85lru', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfqvi2ftlm8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfqvi2ftlm8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a68a88rcwlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a68a88rcwlo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tftoe4gfvsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tftoe4gfvsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-546asrjiniw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-546asrjiniw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55trpomeqay').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55trpomeqay', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yi49zwj1p3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yi49zwj1p3s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x185sdyr6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x185sdyr6o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2euyfafcvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2euyfafcvr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xj8gwrxodul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xj8gwrxodul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-59zqv7k9l8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-59zqv7k9l8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvp3oveo1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvp3oveo1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jylh093r2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jylh093r2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hdjp9d6uzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hdjp9d6uzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdfxpkomidc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdfxpkomidc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bc8c8wob3sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bc8c8wob3sc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48tft88sfy1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48tft88sfy1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-un89ogr30tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-un89ogr30tr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znk2xtf3ga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znk2xtf3ga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mans23skh3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mans23skh3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yv4izhg1kor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yv4izhg1kor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1dth44kegh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1dth44kegh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4v2ua8d9vm5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4v2ua8d9vm5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mt8oqo6enup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mt8oqo6enup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzwdb8z1wod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzwdb8z1wod', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnpbn3j87fm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnpbn3j87fm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2xplmo9w8dy"]=  window.__ectimmers["ecom-2xplmo9w8dy"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-2xplmo9w8dy"]["wmztnw74z"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2xplmo9w8dy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xplmo9w8dy', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-onbj6l0icr"]=  window.__ectimmers["ecom-onbj6l0icr"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-onbj6l0icr"]["pvx43ihui"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-onbj6l0icr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onbj6l0icr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ol1zgcs3n3m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ol1zgcs3n3m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47q0ill72z4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47q0ill72z4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcpgaw463y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcpgaw463y', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cz6o6dgstgg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cz6o6dgstgg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-osues15aod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osues15aod', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8cm3snle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8cm3snle', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70zdeafljgm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70zdeafljgm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg1qzeuyuii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg1qzeuyuii', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8w3krbhi3qa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8w3krbhi3qa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glniuo11c6v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glniuo11c6v', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1scgznvmv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1scgznvmv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzcwqcer63h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzcwqcer63h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m75x2ws4esj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m75x2ws4esj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ueljyg07v5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ueljyg07v5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lnzwudjcb7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lnzwudjcb7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85abvdcph8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85abvdcph8a', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dd2zrzvaobc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dd2zrzvaobc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}